import { initializeApollo } from 'lib/apolloClient';
import { getGlobalData } from 'lib/global.js';
import { getEntityBlocks } from 'gql/common/blocks';
import { CORE_POST_FIELDS, CORE_POST_FIELDS_KEY, FEATURED_POSTS } from 'gql/posts';
import { GetServerSideProps, GetServerSidePropsContext } from 'next';
import { Category, Post } from 'generated-graphql';
import VideoSeries from '@/components/Series/VideoSeries';
import DefaultAsset from '@/components/Series/DefaultAsset';


export default function Resource({
  seriesParts,
  pageBlocks,
}: {
  seriesParts: Post[];
  pageBlocks: Post;
}) {
  const isVideo = !!pageBlocks.categories?.nodes.find((c) => c.name === "Video")
  return (
    <>
      {isVideo ? <VideoSeries pageBlocks={pageBlocks} seriesParts={seriesParts} /> : <DefaultAsset pageBlocks={pageBlocks} seriesParts={seriesParts} />}
    </>
  );
}

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext,
) => {
  const { query } = context;
  const apolloClient = initializeApollo();

  const pageBlocks = await apolloClient.query({
    query: getEntityBlocks('post', CORE_POST_FIELDS, CORE_POST_FIELDS_KEY),
    variables: {
      id: query.slug?.[1],
      idType: 'SLUG',
      asPreview: false,
    },
  });

  const seriesName = pageBlocks.data.post.categories.nodes.find((c: Category) => c.parent?.node.name === "Series").name

  const results = await apolloClient.query({
    query: FEATURED_POSTS,
    variables: { categoryName: seriesName },
  });


  const pageProps = {
    seriesParts: results?.data?.posts?.nodes.filter(
      (post: Post) => post.title !== pageBlocks?.data?.post.title,
    ) || null,
    pageBlocks: pageBlocks?.data.post,
  };

  return await getGlobalData(pageProps, apolloClient);
};
